import { styled, css } from '@mui/material';

const StyledErrorMessage = styled('div')(
  ({ theme }) => css`
    margin-top: ${theme.spacing('SMALL')};
    color: ${theme.palette.error.main};
  `
);

const StyledLabel = styled('label')(
  ({ theme, disabled }) => css`
    display: block;
    margin-bottom: 0.5rem;
    font-size: 1rem;
    font-weight: 450;

    ${disabled &&
    css`
      color: ${theme.palette.gray.gray};
    `}
  `
);

export { StyledErrorMessage as ErrorMessage, StyledLabel as FormLabel };
